import messages_en_CA from './locales/en-CA.json';
import messages_fr_CA from './locales/fr-CA.json';

export default {
  'en-CA': messages_en_CA,
  'fr-CA': messages_fr_CA
};



// WEBPACK FOOTER //
// ./src/translations/translations.js